import React, { useState, useEffect } from 'react'
import Layout from '../component/Layout'
import SubLayout from '../component/SubLayout'
import Header from '../component/Header'
import { FaArrowLeft } from 'react-icons/fa6'
import Container from '../component/Container'
import classes from "./TermsPage.module.css"
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import termsEnglish from "../locales/policies/terms2.english.json"
import termsSwahili from "../locales/policies/terms2.swahili.json"

const languageMap = new Map([
    ["0", termsEnglish],
    ["1", termsSwahili],
    ["2", termsSwahili],
    ["3", termsSwahili],
    ["4", termsSwahili],
]);

const TermsPage = () => {
    const navigate = useNavigate();
    const { selectedLanguage } = useSelector(state => state.languageSlice);
    const [terms, setTerms] = useState(null);

    useEffect(() => {
        const mapped = languageMap.get(selectedLanguage) || languageMap.get("0");
        setTerms(mapped);
    }, [selectedLanguage]);

    if (!terms) return null;

    const { point_1, point_2, point_3, point_4, point_5, point_6, point_7, point_8, point_9, point_10 } = terms;

    return (
        <Layout>
            <SubLayout>
                <Header active={4} hide={true} />

                <button type="button" className={classes.back_button} onClick={() => navigate(-1)}>
                    <FaArrowLeft color='white' />
                </button>

                <Container style={{ gap: "16px" }}>
                    <div className={classes.card}>

                        <div className={classes.cardHeader}>
                            <h1 className={classes.mainTitle}>{terms.title}</h1>
                        </div>

                        <div className={classes.body}>

                            {/* Point 1 */}
                            <section className={classes.section}>
                                <h2 className={classes.heading}>{point_1.p_1_heading_1}</h2>
                                <p className={classes.text}>{point_1.p_1_desc_1}</p>
                            </section>

                            {/* Point 2 */}
                            <section className={classes.section}>
                                <h2 className={classes.heading}>{point_2.p_2_heading_2}</h2>
                                <p className={classes.text}>{point_2.p_2_bullet_1}</p>
                                <p className={classes.text}>{point_2.p_3_bullet_2}</p>
                            </section>

                            {/* Point 3 */}
                            <section className={classes.section}>
                                <h2 className={classes.heading}>{point_3.p_3_heading_3}</h2>
                                <p className={classes.subheading}>{point_3.p_3_bullet_1}</p>
                                <p className={classes.text}>{point_3.p_3_bullet_desc_1}</p>
                                <div className={classes.priceBox}>
                                    <p className={classes.priceItem}>{point_3.p_3_bullet_price_1}</p>
                                    <p className={classes.priceItem}>{point_3.p_3_bullet_price_2}</p>
                                    <p className={classes.priceItem}>{point_3.p_3_bullet_price_3}</p>
                                </div>
                                <p className={classes.subheading}>{point_3.p_3_bullet_2}</p>
                                <p className={classes.text}>{point_3.p_3_bullet_desc_2}</p>
                                <p className={classes.bullet}>{point_3.p_3_bullet_desc_3}</p>
                            </section>

                            {/* Point 4 */}
                            <section className={classes.section}>
                                <h2 className={classes.heading}>{point_4.p_4_heading_4}</h2>
                                <p className={classes.text}>{point_4.p_4_desc_1}</p>
                            </section>

                            {/* Point 5 */}
                            <section className={classes.section}>
                                <h2 className={classes.heading}>{point_5.p_5_heading_5}</h2>
                                <p className={classes.text}>{point_5.p_5_desc_1}</p>
                                <p className={classes.subheading}>{point_5.p_5_bullet_1}</p>
                                <p className={classes.bullet}>{point_5.p_5_bullet_desc_1}</p>
                                <p className={classes.bullet}>{point_5.p_5_bullet_desc_2}</p>
                                <p className={classes.subheading}>{point_5.p_5_bullet_2}</p>
                                <p className={classes.bullet}>{point_5.p_5_bullet_desc_3}</p>
                                <p className={classes.bullet}>{point_5.p_5_bullet_desc_4}</p>
                                <p className={classes.bullet}>{point_5.p_5_bullet_desc_5}</p>
                                <p className={classes.text} style={{ marginTop: "10px" }}>{point_5.p_5_desc_2}</p>
                                <p className={classes.subheading}>{point_5.p_5_bullet_3}</p>
                                <p className={classes.text}>{point_5.p_5_desc_3}</p>
                                <p className={classes.subheading}>{point_5.p_5_bullet_4}</p>
                                <p className={classes.text}>{point_5.p_5_desc_4}</p>
                            </section>

                            {/* Point 6 */}
                            <section className={classes.section}>
                                <h2 className={classes.heading}>{point_6.p_6_heading_6}</h2>
                                <p className={classes.text}>{point_6.p_6_bullet_1}</p>
                                <p className={classes.text}>{point_6.p_6_bullet_2}</p>
                                <p className={classes.text}>{point_6.p_6_bullet_3}</p>
                                <p className={classes.subheading}>{point_6.p_6_bullet_4}</p>
                                <p className={classes.bullet}>{point_6.p_6_bullet_4_desc_1}</p>
                                <p className={classes.bullet}>{point_6.p_6_bullet_4_desc_2}</p>
                                <p className={classes.bullet}>{point_6.p_6_bullet_4_desc_3}</p>
                                <p className={classes.bullet}>{point_6.p_6_bullet_4_desc_4}</p>
                                <p className={classes.bullet}>{point_6.p_6_bullet_4_desc_5}</p>
                                <p className={classes.bullet}>{point_6.p_6_bullet_4_desc_6}</p>
                                <p className={classes.bullet}>{point_6.p_6_bullet_4_desc_7}</p>
                            </section>

                            {/* Point 7 */}
                            <section className={classes.section}>
                                <h2 className={classes.heading}>{point_7.p_7_heading_1}</h2>
                                <p className={classes.text}>{point_7.p_7_bullet_1}</p>
                                <p className={classes.text}>{point_7.p_7_bullet_2}</p>
                                <p className={classes.text}>{point_7.p_7_bullet_3}</p>
                            </section>

                            {/* Point 8 */}
                            <section className={classes.section}>
                                <h2 className={classes.heading}>{point_8.p_8_heading_1}</h2>
                                <p className={classes.text}>{point_8.p_8_desc_1}</p>
                            </section>

                            {/* Point 9 */}
                            <section className={classes.section}>
                                <h2 className={classes.heading}>{point_9.p_9_heading_1}</h2>
                                <p className={classes.text}>{point_9.p_9_bullet_1}</p>
                                <p className={classes.text}>{point_9.p_9_bullet_2}</p>
                                <p className={classes.text}>{point_9.p_9_bullet_3}</p>
                                <p className={classes.text}>{point_9.p_9_bullet_4}</p>
                                <p className={classes.text}>{point_9.p_9_bullet_5}</p>
                                <p className={classes.subheading}>{point_9.p_9_bullet_6}</p>
                                <p className={classes.bullet}>{point_9.p_9_bullet_6_desc_1}</p>
                                <p className={classes.bullet}>{point_9.p_9_bullet_6_desc_2}</p>
                                <p className={classes.bullet}>{point_9.p_9_bullet_6_desc_3}</p>
                                <p className={classes.text}>{point_9.p_9_bullet_7}</p>
                            </section>

                            {/* Point 10 */}
                            <section className={classes.section}>
                                <h2 className={classes.heading}>{point_10.p_10_heading_1}</h2>
                                <p className={classes.text}>{point_10.p_10_bullet_1}</p>
                                <p className={classes.text}>{point_10.p_10_bullet_2}</p>
                            </section>

                        </div>
                    </div>
                </Container>
            </SubLayout>
        </Layout>
    );
};

export default TermsPage;